'use strict';
'use es6';

// Prevent unwanted focus styles

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

require('../listeners/focusStylesListener');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _underscore = require('../utils/underscore');

var _Functions = require('../core/Functions');

var _HideFocusOnClick = require('../utils/HideFocusOnClick');

var _HideFocusOnClick2 = _interopRequireDefault(_HideFocusOnClick);

var _KeyCodes = require('../constants/KeyCodes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = _react2.default.createClass({
  displayName: 'UIClickable',

  propTypes: {
    className: _react.PropTypes.string,
    disabled: _react.PropTypes.bool,
    onClick: _react.PropTypes.func,
    onKeyDown: _react.PropTypes.func,
    tabIndex: _react.PropTypes.number.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      tabIndex: 0
    };
  },
  handleKeyDown: function handleKeyDown(evt) {
    var keyCode = evt.keyCode;
    var _props = this.props,
        onClick = _props.onClick,
        onKeyDown = _props.onKeyDown;


    (0, _Functions.callIfPossible)(onKeyDown, evt);

    // Simulate click on ENTER/SPACE, to emulate button behavior
    if (keyCode === _KeyCodes.ENTER || keyCode === _KeyCodes.SPACE) {
      (0, _Functions.callIfPossible)(onClick, evt);
      if (keyCode === _KeyCodes.SPACE) {
        evt.preventDefault(); // Prevent page from scrolling (#3575)
      }
    }
  },
  handleClick: function handleClick(evt) {
    var _props2 = this.props,
        disabled = _props2.disabled,
        onClick = _props2.onClick;


    if (disabled) {
      evt.preventDefault();
      evt.stopPropagation();
      return;
    }

    (0, _Functions.callIfPossible)(onClick, evt);
  },
  getTabIndex: function getTabIndex(_ref) {
    var disabled = _ref.disabled,
        tabIndex = _ref.tabIndex;

    return disabled ? null : tabIndex;
  },
  render: function render() {
    var propsNotUsedInRender = ['onClick', 'onKeyDown'];

    var _omit = (0, _underscore.omit)(this.props, propsNotUsedInRender),
        className = _omit.className,
        disabled = _omit.disabled,
        tabIndex = _omit.tabIndex,
        rest = _objectWithoutProperties(_omit, ['className', 'disabled', 'tabIndex']);

    return _react2.default.createElement(
      _HideFocusOnClick2.default,
      null,
      _react2.default.createElement('div', _extends({}, rest, {
        'aria-disabled': disabled,
        className: (0, _reactUtils.classNames)('private-clickable', className),
        onClick: this.handleClick,
        onKeyDown: this.handleKeyDown,
        role: 'button',
        tabIndex: this.getTabIndex({ disabled: disabled, tabIndex: tabIndex })
      }))
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/button/UIClickable.js
// module id = 128
// module chunks = 0 1